import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../../../apps/frontend/src/context/ThemeStore';

import PercentileCardLight from '../../../../../apps/frontend/public/img/percentile-card-light.svg';
import PercentileCardDark from '../../../../../apps/frontend/public/img/percentile-card-dark.svg';
import PercentileCardMobileDark from '../../../../../apps/frontend/public/img/percentile-card-mobile-dark.svg';
import PercentileCardMobileLight from '../../../../../apps/frontend/public/img/percentile-card-mobile-light.svg';

import ProjectedPercentileCardLight from '../../../../../apps/frontend/public/img/projected-percentile-card-light.svg';
import ProjectedPercentileCardDark from '../../../../../apps/frontend/public/img/projected-percentile-card-dark.svg';
import ProjectedPercentileCardMobileDark from '../../../../../apps/frontend/public/img/projected-percentile-card-mobile-dark.svg';
import ProjectedPercentileCardMobileLight from '../../../../../apps/frontend/public/img/projected-percentile-card-mobile-light.svg';

import AyjrCardLight from '../../../../../apps/frontend/public/img/AYJR_light_la.webp';
import AyjrCardDark from '../../../../../apps/frontend/public/img/AYJR_dark_la.webp';
import AyjrCardTabletLight from '../../../../../apps/frontend/public/img/AYJR_light_m.webp';
import AyjrCardTabletDark from '../../../../../apps/frontend/public/img/AYJR_dark_m.webp';
import AyjrCardMobileLight from '../../../../../apps/frontend/public/img/AYJR_light_sm.webp';
import AyjrCardMobileDark from '../../../../../apps/frontend/public/img/AYJR_dark_sm.webp';

import { Button } from '../../components/ui/button';

import QuizrrLight from '../../../public/Images/QuizrrWhite.svg';
import QuizrrBlack from '../../../public/Images/QuizrrBlack.svg';
import QuizrrLogoLight from '../../../public/Images/QuizrrLogoLight.svg';
import QuizrrLogoDark from '../../../public/Images/QuizrrLogoDark.svg';
import { SparkleIcon } from '@phosphor-icons/react';

const PercentileCard = ({ percentileData, score, percentile, isProjected = false, url }) => {
  const isSubjectPercentilePresent = percentile?.subjectWisePercentile?.length > 0;
  const { isDarkTheme } = useContext(ThemeContext);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const tabletQuery = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');

    const updateDeviceFlags = () => {
      setIsMobile(mobileQuery.matches);
      setIsTablet(tabletQuery.matches);
    };

    // Initial check
    updateDeviceFlags();

    // Listen for changes
    mobileQuery.addEventListener('change', updateDeviceFlags);
    tabletQuery.addEventListener('change', updateDeviceFlags);

    return () => {
      mobileQuery.removeEventListener('change', updateDeviceFlags);
      tabletQuery.removeEventListener('change', updateDeviceFlags);
    };
  }, []);

  return (
    <div
      className="relative h-[258px] md:max-w-[496px] md:w-full rounded-xl flex-1 lg:flex-initial lg:min-w-0 flex-shrink-0 cursor-pointer overflow-hidden"
      onClick={() => window.open(url, '_blank')}
      style={{
        backgroundImage: `url(${
          isDarkTheme ? (isMobile ? AyjrCardMobileDark : AyjrCardDark) : isMobile ? AyjrCardMobileLight : AyjrCardLight
        })`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: isMobile ? 'cover' : 'auto 100%',
        backgroundPosition: isMobile ? 'center' : 'top right',
      }}
    >
      {/* Gradient Border Overlay */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          padding: '1px', // border thickness
          borderRadius: '12px',
          background: 'linear-gradient(0deg, var(--q3-stroke-light), rgba(255,184,106,0.7))',
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          pointerEvents: 'none',
        }}
      />
      <div className={`flex flex-col justify-center items-center h-full py-11 px-4`}>
        {/* Top Content */}
        <div>
          <div
            className={`text-lg md:text-3xl flex flex-row items-center justify-center gap-1 mt-4 text-[var(--q3-neutral-default)] font-bold whitespace-nowrap`}
          >
            <span className="text-[var(--q3-orange-normal)]">AYJR</span> Rank
          </div>

          {/* <p
            className={`md:text-[88px] text-5xl font-black ${!isProjected ? 'text-[var(--q3-indigo-normal)]' : 'text-[var(--q3-teal-normal)]'} pt-0 md:pt-3`}
          >
            AYJR Rank
          </p> */}

          {/* {!percentile?.combinedScore && percentile?.data && !isProjected && (
            <p class
            Name="text-xs text-[var(--q3-neutral-light)]">Exact Percentile: {percentile?.data}%ile</p>
          )} */}
          <p className="text-sm max-w-[280px] text-center mt-4 text-[var(--q3-neutral-default)]">
            Click Here to view your AYJR Rank & Predicted AIR
          </p>
        </div>

        {/* Bottom Description */}
        <Button className="rounded-full bg-[var(--q3-orange-normal)] hover:bg-[var(--q3-orange-dark)] w-fit border border-[#EAF3FA] mt-[23px]">
          View Scorecard
        </Button>
      </div>
    </div>
  );
};

export default PercentileCard;

function extractData(text) {
  const regex = /JEE Main \d{4} \(\d{1,2} [A-Za-z]+ Shift \d+\)/;
  const match = text?.match(regex);
  return match ? match[0] : null;
}
